import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M32.44 1.72998C28.89 1.72998 25.68 3.41997 23.36 6.15997C21.04 3.41997 17.83 1.72998 14.28 1.72998C7.21003 1.72998 1.46997 8.45998 1.46997 16.76C1.46997 25.06 7.20003 31.79 14.28 31.79C17.83 31.79 21.04 30.1 23.36 27.36C25.68 30.1 28.89 31.79 32.44 31.79C39.51 31.79 45.25 25.06 45.25 16.76C45.25 8.45998 39.51 1.72998 32.44 1.72998Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
